module.exports = __webpack_public_path__ + "img/ertiga-gls.ccc87ed4.png";